// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","cardContainer":"kdYPs_oWulr7MziPOD4QN","shadowlessContainer":"_3JDaQiq-8Hsn3n-dXP-csT"};